import {useEffect} from "react";
import {useParams} from "react-router-dom";
import {useProductListBanners} from "../ProductListBannersContext";
import {ProductListBanner} from "../types";

export function useSynchronizeProductListBanners(): ProductListBanner[] {
    const {filter, id} = useParams<"filter" | "id">();
    const {banners, refreshForProductList} = useProductListBanners();

    useEffect(() => {
        void refreshForProductList(filter, id);
    }, [filter, id, refreshForProductList]);

    return banners;
}
